export default function formatTimeAgo(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;

  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffYears >= 1) {
    return diffYears === 1 ? '1 ano atrás' : `${diffYears} anos atrás`;
  }

  if (diffMonths >= 1) {
    return diffMonths === 1 ? '1 mês atrás' : `${diffMonths} meses atrás`;
  }

  if (diffWeeks >= 1) {
    return diffWeeks === 1 ? '1 semana atrás' : `${diffWeeks} semanas atrás`;
  }

  if (diffDays >= 1) {
    return diffDays === 1 ? '1 dia atrás' : `${diffDays} dias atrás`;
  }

  return 'Hoje';
}
